import { render, staticRenderFns } from "./ErrorPanel.vue?vue&type=template&id=22447d22&"
import script from "./ErrorPanel.vue?vue&type=script&lang=js&"
export * from "./ErrorPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports